import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';

const useTextOrderByCarList = () => {
  const { t } = useTranslation(i18nNS.car);
  const { tKey } = useComponentTKey('orderByCarList');
  const newOrderByCarList = [
    {
      label: t(tKey('Price')),
      icon: 'dollar',
      value: 'MinimumfarePerDay',
    },
    {
      label: t(tKey('Distance')),
      icon: 'mark',
      value: 'PickupDistance',
    },
    {
      label: t(tKey('Company')),
      icon: 'building',
      value: 'VendorName',
    },
    {
      label: t(tKey('Type')),
      icon: 'car',
      value: 'Class',
    },
  ];

  return [newOrderByCarList];
};

export default useTextOrderByCarList;
